module.exports = __webpack_public_path__ + "img/20.4ca1d2f4.png";